import { render, staticRenderFns } from "./ContactInfoSection.vue?vue&type=template&id=fd774eb4&scoped=true&"
import script from "./ContactInfoSection.vue?vue&type=script&lang=js&"
export * from "./ContactInfoSection.vue?vue&type=script&lang=js&"
import style0 from "./ContactInfoSection.vue?vue&type=style&index=0&id=fd774eb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd774eb4",
  null
  
)

export default component.exports